<div class="system-reset-dialog">
  <div class="dialog-accent-bar"></div>

  <div class="dialog-body">
    <div class="dialog-icon">
      <mat-icon>update</mat-icon>
    </div>

    <h2 mat-dialog-title>System Update Available</h2>

    <p class="dialog-message">
      Updates have been made to YeeHro. You will not see the changes until your browser is refreshed.
    </p>

    <div class="countdown-badge">
      <span class="badge">
        Auto-refresh in <span class="countdown-number">{{ currentTimeRemaining }}</span> seconds
      </span>
    </div>

    <mat-dialog-actions>
      <button mat-stroked-button mat-dialog-close (click)="closeDialog(false)">
        @if (minutesUntilReminder) {
          Remind me in {{ minutesUntilReminder }} {{ (minutesUntilReminder !== 1) ? 'minutes' : 'minute' }}
        } @else {
          Remind me later
        }
      </button>

      <button mat-flat-button color="primary" mat-dialog-close (click)="closeDialog(true)">Refresh Now</button>
    </mat-dialog-actions>
  </div>
</div>
